import React from 'react';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Image from 'assets/images/get_consultation.avif';

const Wrapper = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 25,
  position: 'relative',
  cursor: 'pointer',
  overflow: 'hidden',
  borderRadius: 15,
  padding: 0,
  '& img': {
    transition: 'all 0.2s',
    width: '100%',
    objectFit: 'cover'
  },
  '&:hover': {
    backgroundColor: 'transparent',
    '& img': {
      transform: 'scale(1.05)'
    }
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    '& img': {
      height: 185
    }
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: 20
  }
}));

const AbsoluteFlex = styled('div')(() => ({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  justifyContent: 'flex-end'
}));

const Label = styled(Typography)(({ theme }) => ({
  fontSize: 21,
  fontWeight: 600,
  color: theme.palette.black.main,
  backgroundColor: theme.palette.secondary.main,
  padding: 18,
  textAlign: 'center',
  borderRadius: 15,
  display: 'flex',
  alignSelf: 'cebter',
  flex: 1,
  flexDirection: 'column',
  maxWidth: 480,
  marginRight: 30,
  [theme.breakpoints.down('md')]: {
    margin: 16,
    fontSize: 16
  }
}));

const GetConsultationComponent = ({ handleGetConsultation, t }) => {
  return (
    <Wrapper onClick={handleGetConsultation} tabIndex={0}>
      <img src={Image} alt="Get consultation" />
      <AbsoluteFlex>
        <Label>
          <span>{t('GetConsultation')}</span>
          <span>{t('GetConsultation2')}</span>
        </Label>
      </AbsoluteFlex>
    </Wrapper>
  );
};

export default GetConsultationComponent;
